import user from '@/stores/user'
import { Toast } from 'antd-mobile'
import Axios, { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios'
import { ERROR_STATUS, HTTP_STATUS, ResCode } from './config'
import { getHeader } from './utils'

const instance = Axios.create({
  baseURL: '/',
  timeout: 5000,
  validateStatus: (status) => status < 500,
})
instance.defaults.headers.common['Content-Type'] = 'application/json'

type ResData<T = any> = {
  code: number
  data?: T
  msg?: string
  message?: string
}
type Reject = {
  code: number
  message?: string
  data?: any
}

instance.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    // log请求
    console.log(
      config.method?.toUpperCase() + '--->' + config.baseURL + config.url,
      config.data || config.params,
    )
    // 设置headers
    const baseHeaders = await getHeader()
    config.headers = Object.assign({}, config.headers, baseHeaders)
    return config
  },
  (err: AxiosError) => console.log('req error', JSON.stringify(err)),
)

instance.interceptors.response.use(
  (res: AxiosResponse<ResData<any>>) => {
    // log响应
    console.log(
      res.config.method?.toUpperCase() + '<---' + res.config.baseURL + res.config.url,
      res.data,
    )

    // 响应错误处理
    if (res.status === HTTP_STATUS.NOT_FOUND) {
      return Promise.reject({ code: res.status, message: '请求资源不存在' })
    } else if (res.status === HTTP_STATUS.BAD_GATEWAY || res.status === HTTP_STATUS.SERVER_ERROR) {
      return Promise.reject({
        code: res.status,
        message: '服务端出现了问题',
      })
    } else if (res.status === HTTP_STATUS.FORBIDDEN) {
      authInvalid()
      // TODO 根据自身业务修改
      return Promise.reject({ code: res.status, message: '没有权限访问' })
    } else if (res.status === HTTP_STATUS.AUTHENTICATE) {
      authInvalid()
      return Promise.reject({ code: res.status, message: '需要鉴权' })
    } else if (res.status === HTTP_STATUS.SUCCESS) {
      if (res.data instanceof ArrayBuffer) {
        // download 图片
        return res.data
      }
      // 定义好的错误码
      const { code } = res.data
      if (ERROR_STATUS[code]) {
        if (code === ResCode.TokenInvalid) {
          authInvalid()
        }
        Toast.show(ERROR_STATUS[code])
        console.error(code, ERROR_STATUS[code])
        const reject: Reject = {
          code,
          message: ERROR_STATUS[code],
          data: res.data?.data,
        }
        return Promise.reject(reject)
      }

      return res.data.data
    } else {
      const reject: Reject = {
        code: res.status,
        message: res.statusText,
        data: res.data?.data,
      }
      return Promise.reject(reject)
    }
  },
  (err: AxiosError) => console.log('res error', JSON.stringify(err)),
)

// 登录失效
const authInvalid = () => {
  Toast.show('登录状态失效，跳转登录')
  user.reset()
  // pageToLogin()
}

const request = <D = any, T = any>(config: AxiosRequestConfig<D>) => {
  const { method = 'GET' } = config
  if (method === 'get' || method === 'GET') {
    config.params = config.data
    config.data = undefined
  }
  return instance.request<ResData<T>>(config)
}

const Get = <D = any, T = any>(url: string, data?: D, headers?: any) => {
  return request<D, T>({ url, method: 'get', data, headers })
}
const Post = <D = any, T = any>(url: string, data?: D, headers?: any) => {
  return request<D, T>({ url, method: 'post', data, headers })
}
const Put = <D = any, T = any>(url: string, data?: D, headers?: any) => {
  return request<D, T>({ url, method: 'put', data, headers })
}
const Delete = <D = any, T = any>(url: string, data?: D, headers?: any) => {
  return request<D, T>({ url, method: 'delete', data, headers })
}

const http = {
  request: request,
  get: Get,
  post: Post,
  put: Put,
  delete: Delete,
}

export default http
